<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-file-upload" class="q-mb-sm" /> {{ $t('imports') }}
        </div>

        <q-table
            :data="imports"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            :filter="filter"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
        >

            <template slot="top" slot-scope="props" :props="props">
                <q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />
                <div class="col" />
                <q-btn class="q-mr-sm" color="green" icon="far fa-file-spreadsheet" :label="$t('users')" @click="generateTemplate(1)" >
                    <q-tooltip>
                            {{ $t('download_user_import_template_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                <q-btn class="q-mr-xl" color="green" icon="far fa-file-spreadsheet" :label="$t('companies_and_branches')" @click="generateTemplate(2)" >
                    <q-tooltip>
                            {{ $t('download_headquarter_branch_import_template_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                <q-btn color="secondary" icon="far fa-plus" :label="$t('new')" @click="$router.push({ name: 'admin_import', params: { id: 0 } })" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="import_type" :props="props">
                    {{ $t(getImportType(props.row.import_type)) }}
                </q-td>

                <q-td key="created_date" :props="props">
                    {{ props.row.created_date }}
                </q-td>

                <q-td key="status" :props="props" auto-width>
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="far fa-pencil-alt" @click="$router.push({ name: 'admin_import', params: { id: props.row.actions } })" >
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import { LocalStorage } from 'quasar'
export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'imports', 'admin'] },

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 5,
                descending: false,
                sortBy: null
            },
            loading: false,
            imports: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: true,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'import_type',
                    required: true,
                    label: 'import_type',
                    align: 'left',
                    field: 'import_type',
                    sortable: true,
                },
                {
                    name: 'created_date',
                    required: true,
                    label: 'created_date',
                    align: 'left',
                    field: 'created_date',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            filter: '',
            action_id: '',
            confirm_remove: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_client_country_selected: 'common/id_user_client_country_selected',
            reload_content: 'common/reload_content',
            areas: 'registration_lists/country_areas'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }
            this.saveFilter();

            this.$axios.get('/admin_import/import_new/?' + this.$qs.stringify(data), this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.imports = []
                response.data.results.forEach(result => {
                    this.imports.push({
                        id: result.id,
                        title: result.title,
                        import_type: result.import_type,
                        created_date: date.formatDate(result.created_date, 'DD/MM/YYYY HH:mm:ss'),
                        status: result.status,
                        actions: result.id
                    })
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        fetchLists() {
            this.$q.loading.show()

            this.$axios.get('/accounts/get_registration_lists/', this.getHeader)
            .then(response => {
                this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        generateTemplate(import_type) {
            let message = this.$t('generating_import_file_message')
            this.$q.loading.show({
                message
            })
			this.$axios.get('/admin_import/import_new/generate_template/?import_type=' + import_type, this.getHeader)
			.then(response => {
				this.forceFileDownload(response.data.path_url)
			})
			.catch(e => {
				console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            })
        },

        forceFileDownload(response){
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
        },

        getFeatured(featured) {
            if (featured == 1) return 'yes'
            else return 'no'
        },

        getStatus(status) {
            if (status == 1) return 'finalized'
            else if (status == 2) return 'validated'
            else if (status == 3) return 'awaiting'
            else if (status == 4) return 'with_errors'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fal fa-exclamation-triangle'
            else if (status == 3) return 'fal fa-question-circle'
            else if (status == 4) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'info'
            else if (status == 3) return 'warning'
            else if (status == 4) return 'negative'
        },

        getImportType(type) {
            if (type == 1) return 'users'
            else return 'companies_and_branches'
        },

        saveFilter() {
            let dataTableTags = {
                "rowsPerPage": this.server_pagination.rowsPerPage,
                "filter": this.filter
            }
            this.$q.localStorage.set('dataTableTags', dataTableTags)

        },

        loadFilter() {
            if (this.$q.localStorage.has('dataTableTags')) {
            let tags = this.$q.localStorage.get.item('dataTableTags')
            this.server_pagination.rowsPerPage = tags.rowsPerPage
            this.filter = tags.filter
          }
        },
    },

    watch: {
        reload_content: function() {
            this.request({
                pagination: this.server_pagination
            })
        }
    },

    created() {
      this.loadFilter()
      this.fetchLists()
    }
}
</script>

<style lang="stylus" scoped>

</style>
